import { NumberInput, Select, Stack, Text } from '@mantine/core';

import { CURRENCIES } from '../../config';
import { useSimulationFormContext } from '../../hooks';

export const UnderwritingForm = () => {
  const { form } = useSimulationFormContext();

  return (
    <Stack gap="sm" w="100%">
      <Text size="sm" c="dimmed">
        Simulate a Wayflyer offer approval by entering an amount and currency below, which will display in the banner
        above. Leave both fields blank to use a default offer amount.
      </Text>
      <Select
        label="Currency"
        placeholder="Enter Currency"
        searchable
        data={CURRENCIES}
        clearable
        comboboxProps={{
          withinPortal: false,
        }}
        {...form.getInputProps('currency')}
      />
      <NumberInput
        label="Approved amount"
        placeholder="Enter Approved amount"
        allowNegative={false}
        hideControls
        {...form.getInputProps('approved_amount')}
      />
    </Stack>
  );
};
